var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-tab"},_vm._l((_vm.options),function(item,index){return _c('div',{key:index,staticClass:"radio-tab-item",class:item.value == _vm.tabVal ? 'active' : '',on:{"click":function($event){return _vm.handleItemClick(item.value)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a7c2734","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/YxGbTableDisplay/RadioTab.vue
// module id = null
// module chunks = 